import { render, staticRenderFns } from "./articole.vue?vue&type=template&id=28b3e76c&"
import script from "./articole.vue?vue&type=script&lang=js&"
export * from "./articole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports